module.exports = __webpack_public_path__ + "static/media/Ahmed.82c33d5f.jpeg";